(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trCodeContainer', trCodeContainer);

  function trCodeContainer() {
    const directive = {
      restrict: 'E',
      scope: {
        codeSnippet: '=',
        successTranslation: '@',
        preClass: '@'
      },
      controller: CodeContainerController,
      controllerAs: 'vm',
      transclude: true,
      templateUrl: '/scripts/shared/directives/code-container/code-container.partial.html'
    };
    return directive;

    function CodeContainerController(
      $scope,
      $filter,
      $timeout,
      toaster
    ) {
      'ngInject';

      const vm = this;

      vm.handleCodeContainerClick = handleCodeContainerClick;
      vm.showCopiedNotification = showCopiedNotification;

      function handleCodeContainerClick() {
        vm.codeCopied = !vm.codeCopied;
        showCopiedNotification();
        $timeout(function () {
          vm.codeCopied = !vm.codeCopied;
        }, 100);
      }

      function showCopiedNotification() {
        toaster.pop({
          type: 'success',
          timeout: 3000,
          body: $filter('translate')($scope.successTranslation)
        });
      }
    }

  }
})();
